import "./bootstrap.js";
import { createInertiaApp } from "@inertiajs/react";
import { createRoot } from "react-dom/client";
import { PreviewWrapper, AddButton } from "@ciklik/visual-editor";

window.customElements.define("ve-wrapper", PreviewWrapper);
window.customElements.define("ve-add", AddButton);

createInertiaApp({
  resolve: (name) => {
    const views = import.meta.glob("./views/**/*.tsx");
    return views[`./views/${name}.tsx`]();
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />);
  },
});
